import * as React from 'react';

const getPath = (company: any) => {
  switch (company) {
    case 'facebook':
      return (
        <path
          fill='#ffffff'
          d='M8.7 10.5H5.9c0 4.3 0 9.5 0 9.5H1.9c0 0 0-5.2 0-9.5H0V7.2h1.9V5C1.9 3.4 2.7 1 6 1l3 0v3.3c0 0-1.8 0-2.2 0 -0.3 0-0.8 0.2-0.8 0.9v2H9L8.7 10.5z'
        />
      );
    case 'twitter':
      return (
        <path
          fill='#ffffff'
          d='M17.1 6c0 0.2 0 0.4 0 0.5C17.1 11.9 13.2 18 6 18c-2.2 0-4.2-0.7-6-1.8 0.3 0 0.6 0.1 0.9 0.1 1.8 0 3.5-0.6 4.8-1.7 -1.7 0-3.1-1.2-3.6-2.8 0.2 0.1 0.5 0.1 0.7 0.1 0.4 0 0.7 0 1-0.1 -1.8-0.4-3.1-2-3.1-4 0 0 0 0 0 0 0.5 0.3 1.1 0.5 1.8 0.5C1.5 7.4 0.8 6.2 0.8 4.8c0-0.7 0.2-1.4 0.5-2 1.9 2.4 4.8 4.1 8 4.2 -0.1-0.3-0.1-0.6-0.1-0.9C9.3 3.8 11 2 13.2 2c1.1 0 2.1 0.5 2.8 1.3 0.9-0.2 1.7-0.5 2.5-1 -0.3 0.9-0.9 1.7-1.7 2.2 0.8-0.1 1.5-0.3 2.2-0.6C18.5 4.7 17.8 5.4 17.1 6z'
        />
      );
    case 'google':
      return (
        // <path
        //   fill="#ffffff"
        //   d="M18.6 13.4c-0.4 1.6-1.3 3-2.4 4.2 -1.1 1.1-2.5 1.8-4 2.1 -1.6 0.4-3.3 0.4-5-0.1 -1.3-0.3-2.5-1-3.5-1.8 -1.1-0.9-2-2-2.6-3.3 -1-2-1.3-4.3-0.8-6.5C0.4 7.2 0.6 6.3 1 5.5c1.1-2.3 3.1-4.1 5.5-5 2.1-0.7 4.5-0.7 6.5 0.1 1.2 0.4 2.2 1.1 3.1 2 -0.3 0.3-0.6 0.7-0.9 1 -0.6 0.6-1.2 1.2-1.8 1.8 -0.6-0.6-1.3-1-2.1-1.3 -0.9-0.3-1.9-0.3-2.8-0.1C7.4 4.3 6.4 4.9 5.6 5.7 5 6.4 4.5 7.2 4.2 8.1c-0.4 1.3-0.4 2.6 0 3.9 0.4 1.2 1.2 2.3 2.2 3.1 0.6 0.5 1.4 0.8 2.2 1 0.8 0.2 1.6 0.1 2.3 0 0.8-0.1 1.5-0.4 2.1-0.9 1-0.7 1.7-1.8 1.9-3.1 -1.8 0-3.5 0-5.3 0 0-1.3 0-2.6 0-3.9 3 0 6.1 0 9.1 0C19.1 9.9 19.1 11.7 18.6 13.4z"
        // />
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            fill='#4285F4'
            d='M20 10.2c0-0.7-0.1-1.4-0.2-2h-9.6v3.9h5.5c-0.2 1.2-1 2.3-2 3v2.5H17C18.9 15.8 20 13.3 20 10.2L20 10.2z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            fill='#34A853'
            d='M10.2 20c2.8 0 5.1-0.9 6.8-2.4l-3.3-2.5c-0.9 0.6-2.1 1-3.5 1 -2.7 0-4.9-1.8-5.7-4.1H1.1v2.6C2.8 17.8 6.2 20 10.2 20L10.2 20z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            fill='#FBBC05'
            d='M4.5 11.9c-0.2-0.6-0.3-1.2-0.3-1.9s0.1-1.3 0.3-1.9V5.5H1.1C0.4 6.9 0 8.4 0 10s0.4 3.1 1.1 4.5L4.5 11.9 4.5 11.9z'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            fill='#EA4335'
            d='M10.2 4c1.5 0 2.8 0.5 3.9 1.5L17 2.6C15.3 1 13 0 10.2 0c-4 0-7.4 2.2-9.1 5.5l3.4 2.6C5.3 5.7 7.5 4 10.2 4L10.2 4z'
          />
        </>
      );
    case 'apple':
      return (
        <path
          fill='#ffffff'
          d='M11 3.5c0.7-0.9 1.2-2.2 1-3.5 -1 0-2.2 0.7-2.9 1.6 -0.6 0.8-1.2 2.1-1 3.4C9.1 5.1 10.3 4.4 11 3.5zM13.4 10.7c0-2.5 2-3.7 2.1-3.8 -1.1-1.7-2.9-1.9-3.6-2 -1.5-0.2-3 0.9-3.8 0.9 -0.8 0-2-0.9-3.2-0.9C3.2 5.1 1.7 6 0.8 7.5c-1.7 3-0.4 7.5 1.3 10 0.8 1.2 1.8 2.6 3.1 2.5 1.3 0 1.7-0.8 3.2-0.8 1.5 0 1.9 0.8 3.2 0.8 1.3 0 2.2-1.2 3-2.4 1-1.4 1.3-2.7 1.4-2.8C16 14.7 13.4 13.7 13.4 10.7z'
        />
      );
    default:
      return <path />;
  }
};

export const SocialIcon = ({
  company = '',
  size = '20',
  className = '',
  viewBox = '0 0 20 20',
}) => (
  <svg
    width={size}
    height={size}
    viewBox={viewBox}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    {getPath(company)}
  </svg>
);

export default SocialIcon;
